(function(_){
    'use strict';
    _['CART.KEY']='Cart';
    _['CART.CONFIRM']='Confirm';
    _['CART.NEXT']='Next';
    _['CART.EMPTY-CART']='Cart is empty!';
    _['CART.ADDRESS']='Address';
    _['CART.ORDER']='Order';
    _['CART.PAYMENT']='Payment';
    _['CART.PRODUCT-ADDED']='{0} products added to the cart';
    _['CART.PRODUCT-ADDED(1)']='{0} product added to the cart';
    _['CART.GO-TO-CART']='Go to cart';
    _['CART.CONTINUE']='Continue';
    _['CART.AMOUNT']='Amount';
    _['CART.PRICE']='Price';
    _['CART.TOTAL']='Total';

	_['CART.ORDER.REMOVE']='Remove product';
    _['CART.ORDER.PRICES.TITLE']='Shipping Summary';
    _['CART.ORDER.PRICES.TOTAL']='Price';
    _['CART.ORDER.PRICES.TAXES']='Taxes';
    _['CART.ORDER.PRICES.SHIPPING-CHARGES']='Shipping charges';
    _['CART.ORDER.PRICES.TOTALWITHTAXES']='Price w/ taxes';
    _['CART.ORDER.PRICES.TOTALWITHTAXESUSD']='Price w/ taxes (USD)';
    _['CART.ORDER.PRICES.WARNING.TEXT']='Currency not supported by PayPal. Please note that this payment will be carried out in USD and your bank will calculate the final conversion rates.';

    _['CART.STOCK-STATUS']='Stock Status';
    _['CART.STOCK-STATUS.OK']='OK';
    _['CART.STOCK-STATUS.OK.DESC']='All products have stock';
    _['CART.STOCK-STATUS.ERR']='Err';
    _['CART.STOCK-STATUS.ERR.DESC']='Some products are out of stock';
    _['CART.FINAL-PRICE']='Final price';
    _['CART.ORDER.REMOVAL-CONFIRM.TITLE']='Remove product of order';
    _['CART.ORDER.REMOVAL-CONFIRM.MSG']='Are you really sure?';
    _['CART.ADDRESS.EDIT']='Edit';
    _['CART.ADDRESS.SHIPPING']='Shipping Address';
    _['CART.ADDRESS.BILLING']='Billing Address';
    _['CART.ADDRESS.OBSERVATIONS']='Observations';
    _['CART.ADDRESS.PAYMENT_MODEL']='Payment method';
    _['CART.ADDRESS.PAY_WITH_REDSYS']='Pay now with Credit Card';
    _['CART.ADDRESS.PAY_WITH_PICK_AT_STORE']='Pay when pick at store';
    _['CART.ADDRESS.PAY_WITH_PAYPAL']='Pay now with PayPal';
    _['CART.ADDRESS.PAY_WITH_REFUND']='Pay on delivery';
    _['CART.ADDRESS.PAY_WITH_WIRE_TRANSFER']='Pay through wire transfer';
    _['CART.ADDRESS.NO.PAYMENT_MODEL.MSG']='There is no payment type enabled. Contact with the app admin / manager to enable a payment type.';

    _['CART.ADDRESS.SAME-AS-SHIPPING']='As shipping';

    _['CART.PAYMENT.PAYPAL.ADVICE']='You will be redirected to the PayPal website to do the payment.';
    _['CART.PAYMENT.PAYPAL.REDIRECTING']='Redirecting to Paypal';
    _['CART.PAYMENT.PAYPAL.BTN']='Pay now!';
    _['CART.PAYMENT.REFUND.ADVICE']='You will confirm the payment for your order. Check all order info and push "Confirm order!" button.';
    _['CART.PAYMENT.REFUND.REDIRECTING']='Confirm your order';
    _['CART.PAYMENT.REFUND.BTN']='Pay now!';
    _['CART.PAYMENT.WIRE_TRANSFER.ADVICE']='You will confirm the payment for your order. Check all order info and push "Confirm order!" button.';
    _['CART.PAYMENT.WIRE_TRANSFER.REDIRECTING']='Confirm your order';
    _['CART.PAYMENT.WIRE_TRANSFER.BTN']='Confirm order!';
    _['CART.PAYMENT.REDSYS.ADVICE']='You will be redirected to the Redsys website to do the payment.';
    _['CART.PAYMENT.REDSYS.REDIRECTING']='Redirecting to Redsys';
    _['CART.PAYMENT.REDSYS.BTN']='Pay now!';
    _['CART.PAYMENT.PICKATSTORE.BTN']='Confirm your order!';
    _['CART.PAYMENT.PICKATSTORE.ADVICE']='You are going to confirm your order. Check all order info and push "Confirm order!" button.';

    _['CART.PAYMENT.ERR.SERVER.PREPARE.TITLE']='Error in payment.';
    _['CART.PAYMENT.ERR.SERVER.PREPARE.MSG']='There has been an error preparing the payment. Contact with your administrator/seller.';

    _['CART.PAYMENT.WIRE_TRANSFER.TEXT'] = 'You choose the payment through wire transfer. Now you will find the information to make it and the email where you must send your bank receipt.';
    _['CART.PAYMENT.WIRE_TRANSFER.BANK-ACCOUNT'] = 'Bank account number';
    _['CART.PAYMENT.WIRE_TRANSFER.EMAIL'] = 'Email';

    _['CART.PAYMENT.SUCCESS.TITLE']='Your payment has been received';
    _['CART.PAYMENT.SUCCESS.TITLE_RECEIVED']='Your order has been received';
    _['CART.PAYMENT.SUCCESS.TITLE_WIRE_TRANSFER']='Your order has been received';
    _['CART.PAYMENT.SUCCESS.MSG']='Thank you for your payment. Your transaction has been completed, and a receipt for your purchase has been emailed to you.';
    _['CART.PAYMENT.SUCCESS.MSG_RECEIVED']='Thank you for your order. Your order has been completed, and a receipt for your purchase has been emailed to you.';
    _['CART.PAYMENT.SUCCESS.MSG_WIRE_TRANSFER']='Thank you for your order. Your order has been completed, and a receipt for your purchase has been emailed to you.';
    _['CART.PAYMENT.FAILURE.TITLE']='Error processing your payment';
    _['CART.PAYMENT.FAILURE.MSG']='Sorry, we cannot complete your transaction because there has been an error processing the payment. Contact with your administrator/seller.';
    _['CART.PAYMENT.SHIPPINGCHARGES.TITLE'] = 'Shipping Charges';
    _['CART.PAYMENT.SHIPPINGCHARGES.FIXED'] = 'Shipping charges fixed';
    _['CART.PAYMENT.SHIPPINGCHARGES.MSG'] = 'Shipping charges free in this order!';
    _['CART.PAYMENT.PICKATSTOREOPTIONS.TITLE'] = 'Pick at store';
    _['CART.MIMINUMORDER'] = 'The order must be greater than the minimum amount of ';

}(translations['en']));




// WEBPACK FOOTER //
// ./src/app/modules/cart/lang/cart-lang_en.js